import Navbar from "../../Components/Landing Page/NavBar";
import UseCaseHero from "./UseCaseHero";
import UseCaseVideo from "./UseCaseVideo";
import UseCaseStages from "./UseCaseStages";
import UseCaseFAQ from "./UseCaseFAQ";

const ScaleupUseCase = () => {
    const faqData = [
        {
            question: "Who are we?",
            answer:
                "Arkiter is an innovative recruitment technology service that specializes in streamlining your hiring process for top tech talent. We offer a comprehensive suite of tools that help hiring managers assess candidates' technical skills, problem-solving abilities, and fit for a role.",
        },
        {
            question: "How does it work?",
            answer:
                "We have simplified your assessment and hiring process into three simple steps: <br/><br/>" +
                "<b>Create a role:</b> Use our suggestion engine to create a tailored screening process that suits your specific role needs. Once the role is set up, invite candidates to participate in the interview process.<br/><br/>" +
                "<b>Candidates complete the interviews:</b> Candidates will complete the interviews at their own convenience. Arkiter provides a cheat-detection engine and advanced tracking mechanisms, ensuring the integrity of the interviews and verifying that the candidates themselves complete the tasks.<br/><br/>" +
                "<b>Make data-driven hiring decisions with confidence:</b> Upon completion, you will receive a detailed analysis and benchmark of the candidates' performances. You can use our advanced Insights screen to make informed decisions when hiring the top candidates for your organization.<br/><br/>",
        },
        {
            question: "What types of roles can you hire using Arkiter?",
            answer:
                "Currently, you can use Arkiter to interview candidates for Front End, Back End, Full-Stack Engineers, Site Reliability Engineers, and DevOps roles. We are actively working on adding more technical roles in the near future, such as Data Scientists, Data Analysts, and AI-Powered Engineers. We are also constantly adding new roles to our platform, so if you are looking to hire for a specific role that is not currently supported, please contact us. ",
        },
        {
            question:
                "Can you customize the Arkiter interviewing process with your own questions?",
            answer:
                "Certainly. We can assist you in creating and testing custom questions that meet your specific requirements. Once created, these questions will be associated with your account and not shared with other users, ensuring the privacy and security of your interview process.",
        },
        {
            question: "Can you conduct fit interviews with Arkiter?",
            answer:
                "Arkiter is a technical interview platform that helps you assess candidates' technical skills and problem-solving abilities. We do not currently offer fit interviews, as we believe that these are best conducted by experienced team members within the organization who may have a deeper understanding of the company's culture and values.",
        },
        {
            question: "Who can use Arkiter to assess top tech talent?",
            answer:
                "Arkiter is a user-friendly platform that can be used by a wide range of hiring professionals within an organization. Non-technical HR professionals can use the platform to get a high-level overview of candidates' performances, while technical hiring managers can use the platform’s playback feature to go deeper analyzing candidates' solutions. The platform also offers a switch option between normalized values and technical details such as complexity metrics, making it the perfect tool for a variety of hiring professionals.",
        },
        // Add more FAQ items here
    ];

    return (
        <>
            <Navbar/>

            <UseCaseHero
                text1={"Accelerate Your Hiring Efficiency with Arkiter"}
                text2={"Adopt an AI-powered, systematic interviewing process for seamless scaling, featuring skill-specific assessments and efficient candidate matching.\n"}/>

            <UseCaseVideo
                videoUrl={"https://www.loom.com/embed/1d9854e8e06440df940effa1f7f903ba?sid=0e4463e2-d856-47de-a751-d0f36bb9f676"}/>

            <UseCaseStages
                headerPart1 = {"Scale with efficiency"}
                headerPart2 = {"3 significant steps"}

                step1={"Live Interview Platform"}
                step1Description={"Experience scalable and accurate interviewing with Arkiter's live interview platform, offering diverse interview formats."}

                step2={"AI Role Description Generator"}
                step2Description={"Reduce effort spent on role definition by using Arkiter's AI generating optimal role descriptions based on company information and hiring needs."}

                step3={"Benchmarking and Comparison"}
                step3Description={"Arkiter offers an AI-driven benchmarking and comparison feature, providing a quick and comprehensive overview of candidates in a single glance."}
            />

            <UseCaseFAQ faqData={faqData}/>
        </>
    );
};

export default ScaleupUseCase;